import { createFileRoute, redirect } from '@tanstack/react-router'

/** Seção sem tela própria: manda para a primeira tab. */
export const Route = createFileRoute('/_authed/gestao-de-caixa/')({
  beforeLoad: () => {
    throw redirect({ to: '/gestao-de-caixa/resumo' })
  },
})
